var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.renderKey,attrs:{"id":"app"}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.header))]),_c('apexchart',{attrs:{"type":"pie","width":"100%","height":"440","options":_vm.chartOptions,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }